// Copyright © 2026 ApexRuntime Labs by Shashi (https://github.com/spshah). All rights reserved.

import axios from 'axios';
import api from './axios';
import { ACCESS_KEY, REFRESH_KEY, BASE_URL } from './axios';

// Plain instance — no interceptors, used for /token/refresh/ only
// Prevents the 401 interceptor from catching a failed refresh and looping
const axios_plain = axios.create({ baseURL: BASE_URL, timeout: 10_000 });

export const authAPI = {
  login: (email, password) => api.post('/api/token/', { email, password }),
  register: (data) => api.post('/api/register/', data),
  refreshToken: (refresh) =>
    axios_plain.post('/api/token/refresh/', { refresh }),
  getProfile: () => api.get('/api/me/'),
  updateProfile: (data) => api.patch('/api/me/', data),
  // Password change is a special case of the profile PATCH — see
  // UserProfileView.patch (IDP/backend/users/views.py). It requires
  // old_password alongside the new one; 'password' is the new value.
  updatePassword: (old_password, password) =>
    api.patch('/api/me/', { old_password, password }),
  logout: () => {
    localStorage.removeItem(ACCESS_KEY);
    localStorage.removeItem(REFRESH_KEY);
  },
};
